import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/Layout";

Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    redirect: "/cetd/index"
  },
  {
    path: "/cetd",
    name: "cetd",
    component: Layout,
    children: [
      {
        path: "/cetd/index",
        component: () => import("@/pages/index"),
        title: "首页",
        name: "首页",
        meta: { code: "Index", name: "Index", path: "/cetd/index" }
      },
      {
        path: "/cetd/product",
        component: () => import("@/pages/product"),
        title: "产品",
        name: "产品",
        meta: { code: "Product", name: "Product", path: "/cetd/product" }
      },
      {
        path: "/cetd/productList/:categoryId",
        component: () => import("@/pages/productList"),
        title: "产品列表",
        name: "产品列表",
        meta: { code: "ProductList", name: "ProductList", path: "/cetd/productList" }
      },
      {
        path: "/cetd/productDetail/:itemId",
        component: () => import("@/pages/productDetail"),
        title: "产品列表",
        name: "产品列表",
        meta: { code: "ProductDetail", name: "ProductDetail", path: "/cetd/productDetail" }
      },
      {
        path: "/cetd/modelProductList/:modelId",
        component: () => import("@/pages/modelProductList"),
        title: "产品列表",
        name: "产品列表",
        meta: { code: "modelProductList", name: "modelProductList", path: "/cetd/modelProductList" }
      },
      {
        path: "/cetd/about",
        component: () => import("@/pages/about"),
        title: "关于我们",
        name: "关于我们",
        meta: { code: "About", name: "About", path: "/cetd/about" }
      },
      {
        path: "/cetd/contactUs",
        component: () => import("@/pages/contactUs"),
        title: "联系我们",
        name: "联系我们",
        meta: { code: "ContactUs", name: "ContactUs", path: "/cetd/contactUs" }
      },
      {
        path: "/cetd/search",
        component: () => import("@/pages/search"),
        title: "联系我们",
        name: "联系我们",
        meta: { code: "Search", name: "Search", path: "/cetd/search" }
      },
      {
        path: "/cetd/warranty",
        component: () => import("@/pages/warranty"),
        title: "问题列表",
        name: "问题列表",
        meta: { code: "Warranty", name: "Warranty", path: "/cetd/warranty" }
      },
      {
        path: "/cetd/shipment",
        component: () => import("@/pages/shipment"),
        title: "申明",
        name: "申明",
        meta: { code: "Shipment", name: "Shipment", path: "/cetd/shipment" }
      },
      {
        path: "/cetd/businessScope",
        component: () => import("@/pages/businessScope"),
        title: "经验范围",
        name: "经验范围",
        meta: { code: "BusinessScope", name: "BusinessScope", path: "/cetd/businessScope" }
      },
    ]
  }
];
export const asyncRouterMap = [];

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js